export type PaymentListView = "list" | "analysis";

export function paymentListViewFromSearch(search: unknown): PaymentListView {
  return (search as { view?: unknown }).view === "analysis"
    ? "analysis"
    : "list";
}

export function withPaymentListViewSearch(search: Record<string, unknown>): {
  licenseId?: string;
  view?: "analysis";
  overdue?: "30";
} {
  return {
    licenseId:
      typeof search.licenseId === "string" && search.licenseId
        ? search.licenseId
        : undefined,
    view: search.view === "analysis" ? "analysis" : undefined,
    overdue: search.overdue === "30" ? "30" : undefined,
  };
}
